module.exports = __webpack_public_path__ + "img/om.8ced3158.svg";